import api from '@/api';
import { API_BASE_URL } from '..';
import { ReportTasksParams } from './Report.types';

const GENERATE_URL = `${API_BASE_URL}/generate/tasks`;

export async function generateTasksReport(params?: ReportTasksParams) {
  const result = (await api.getReport(GENERATE_URL, params)) as unknown;
  return result as BlobPart;
}
